export default __webpack_public_path__ + "static/media/chat.ba8b6f60.svg";